// Select / autocomplete dropdowns in the profile-menu look (common/MenuCard.vue): a rounded box with rows 4px apart.
// Pair with common/MenuListItem.vue in the #item slot.
export const SELECT_MENU_PROPS = { contentClass: 'rounded-lg' }
export const SELECT_LIST_PROPS = { class: 'd-flex flex-column ga-1 pa-2' }
